import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobProgressionStore } from '@/features/jobs/taxes/progression/JobProgressionStore'
import { computed } from 'mobx'
import { task } from 'mobx-task'
import type { AlertErrorHandlerFactory } from '@/features/shell'

/**
 * Starts the job progression once the documents are in.
 */
export class StartProgressionDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _progressionStore: JobProgressionStore,
    private readonly _job: Job,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Whether the job follows the review flow.
   */
  @computed
  get isReview() {
    return (
      this._progressionStore.progressionForJob(this._job.id)
        ?.progressionFlow === 'Review'
    )
  }

  /**
   * Moves the job to job started and closes the dialog.
   */
  startJobProgression = task.resolved(async () => {
    await this._progressionStore
      .transitionToStep(this._job.id, { step: 'JobStarted' })
      .catch(this._createAlertErrorHandler('Starting the job failed'))
    this.modal.close()
  })
}
